import type { APIResult } from "./types";

import { getMaintenanceVehicleCondition } from "./generated/calls/maintenance-vehicle-condition/maintenance-vehicle-condition";
import type { MaintenanceVehicleCondition as MaintenanceVehicleConditionDTO } from "./generated/models";
import { buildHeaders } from "./helpers/headerHelper";
import { postgrestError } from "./helpers/postgrestErrorHelper";

export type { MaintenanceVehicleConditionDTO };

/**
 * Fetches all fleet maintenance vehicle condition checks from the API.
 *
 * Returns an API result containing the fetched vehicle condition checks, or
 * a controlled failure if the request could not be completed.
 */
export async function fetchFleetMaintenanceVehicleCondition(): Promise<
  APIResult<MaintenanceVehicleConditionDTO[]>
> {
  try {
    const headers = buildHeaders();
    const vehicleConditionFetchRes = await getMaintenanceVehicleCondition(
      undefined,
      { headers },
    );

    switch (vehicleConditionFetchRes.status) {
      // A read narrowed by `limit`, `offset` or a `Range` header answers 206
      // and carries the same rows as a 200.
      case 200:
      case 206:
        return {
          success: true,
          data: vehicleConditionFetchRes.data,
        };
      default:
        throw postgrestError("Fetch failed", vehicleConditionFetchRes);
    }
  } catch (error) {
    return {
      success: false,
      errorMsg:
        error instanceof Error ? error.message : "an unknown error occurred",
    };
  }
}
